import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-04/lesson-21/task-01";

const task: Slide = {
  titleHtml:
    "The diaphragm velocity of a loudspeaker mounted in a vented box (with f<sub>b</sub>&nbsp;=&nbsp;f<sub>s</sub>) is:",
  description: "Select the correct answer(s).",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
